module.exports = "/images/vendor/flag-icon-css/flags/1x1/ai.svg?9fe4d6b75d40228a802475e855522ad0";